<span *ngIf="isLegacyIcon" [class]="iconClass">
  <img *ngIf="legacyIconSrc" [src]="legacyIconSrc" />
</span>
<i
  *ngIf="!isLegacyIcon"
  nz-icon
  [nzType]="iconType"
  [nzTheme]="iconTheme"
  [nzSpin]="iconSpin"
  [nzTwotoneColor]="iconTwotoneColor"
  [nzIconfont]="iconIconfont"
  [nzRotate]="iconRotate"
  ui-tooltip
  [tooltipContent]="tooltipContent | localize"
  [tooltipPosition]="tooltipPosition"
  [tooltipContainer]="tooltipContainer"
  tooltipContainerClass="ink-80-tooltip"
  [tooltipDisabled]="!showTooltip"></i>
